import { LargePart, Section, SmallPart } from 'components/Styled';
import { useGlobalState } from 'contexts/GlobalState';

const supportLogos = [
	"ford",
	"opensociety",
	"uk",
];

const partnerLogos = [
	"artigo",
	"datalab",
	"flup",
	"google",
	"inhotim",
	"instituto-update",
	"mulheres-negras-decidem",
	"museudoamanha",
	"thoughtworks"
];

export default function Partners() {
	const [websiteText] = useGlobalState("websiteText");
	const [selectedLanguage] = useGlobalState("selectedLanguage");

	return (
		<>
			{/* Seção de Apoiadores */}
			<Section className='py-20' style={{ backgroundColor: "#cc1c56" }}>
				<SmallPart className='pl-5'>
					<p className='text-sm text-white opacity-40 mb-8'>
						{websiteText.apoiadores_titulo[selectedLanguage]}
					</p>
					<div className="flex gap-8 items-center justify-start overflow-x-auto">
						{supportLogos.map((logo) => (
							<div key={logo} className="flex items-center justify-center w-40 h-24 bg-white/10 backdrop-blur rounded-lg p-4 shrink-0">
								<img
									src={`/assets/l-${logo}.png`}
									alt={logo}
									className="object-contain w-full h-full"
								/>
							</div>
						))}
					</div>
				</SmallPart>
			</Section>

			{/* Seção de Parceiros */}
			<Section className='py-20' style={{ backgroundColor: "white" }}>
				<LargePart className='pl-5 md:pl-10'>
					<p className='text-sm text-gray-800 mb-8 font-medium'>
						{websiteText?.parceiros_titulo?.[selectedLanguage] ?? ""}
					</p>
					<div className="flex flex-wrap gap-8 items-center justify-start">
						{partnerLogos.map((logo) => (
							<div key={logo} className="flex items-center justify-center w-40 h-24 bg-white rounded-lg p-4">
								<img
									className='object-contain w-full h-full'
									src={`/assets/l-${logo}.png`}
									alt={logo}
								/>
							</div>
						))}
					</div>
				</LargePart>
			</Section>
		</>
	);
}
